export default {
  video_player_title: "Video Player",
};
